<ng-template #settingsTemplate>
    <app-tool-setting label="Tijd">
        <app-range-slider
            [max]="60"
            [(range)]="rangeMinutes"
            (rangeChange)="rangeUpdated($event, timeTypes.minutes)"
            label="Minuten"
        ></app-range-slider>
        <app-range-slider
            [max]="rangeMinutes === 60 ? 0 : 59"
            [min]="rangeMinutes > 0 ? 0 : 5"
            [(range)]="rangeSeconds"
            (rangeChange)="rangeUpdated($event, timeTypes.seconds)"
            label="Secondes"
        ></app-range-slider>
    </app-tool-setting>
    <app-tool-setting label="Geluid">
        <app-select-audio-option
            [(value)]="audioId"
            (valueChange)="audioIdUpdated(audioPlayer)"
        ></app-select-audio-option>
        <bbvms-audio
            hidden
            #audioPlayer
            [data-audio-id]="audioId"
            class="asset--small"
        ></bbvms-audio>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        class="svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 85.1 99.11"
    >
        <defs>
            <style>
                .timer_cls-1 {
                    isolation: isolate;
                }
                .timer_cls-2 {
                    fill: #dfeff9;
                }
                .timer_cls-11,
                .timer_cls-3,
                .timer_cls-8 {
                    fill: none;
                }
                .timer_cls-11,
                .timer_cls-3 {
                    stroke: #0090c9;
                }
                .timer_cls-3 {
                    stroke-width: 0.45px;
                }
                .timer_cls-12,
                .timer_cls-4,
                .timer_cls-7 {
                    fill: #0090c9;
                }
                .timer_cls-5 {
                    fill: #fff;
                }
                .timer_cls-6 {
                    fill: #1d1d1b;
                }
                .timer_cls-7 {
                    mix-blend-mode: multiply;
                }
                .timer_cls-8 {
                    stroke: #e52a22;
                }
                .timer_cls-11,
                .timer_cls-8 {
                    stroke-width: 0.5px;
                }
                .timer_cls-9 {
                    fill: #e52a22;
                }
                .timer_cls-10 {
                    fill: #e1042d;
                }
                .timer_cls-12 {
                    font-size: 7px;
                    font-family: UniversLTStd;
                    font-weight: 500;
                }
                .timer_cls-13 {
                    letter-spacing: -0.02em;
                }
                .timer_cls-14 {
                    letter-spacing: 0.06em;
                }
            </style>
        </defs>
        <g class="timer_cls-1">
            <g id="playbutton">
                <rect
                    class="timer_cls-2"
                    x="21.05"
                    y="88.69"
                    width="43.39"
                    height="10.19"
                    rx="2.96"
                />
                <rect
                    class="timer_cls-3"
                    x="21.05"
                    y="88.69"
                    width="43.39"
                    height="10.19"
                    rx="2.96"
                />
                <path
                    (click)="start()"
                    class="timer_cls-4"
                    d="M31.61,93.56a14.56,14.56,0,0,0-2.93-2.3.35.35,0,0,0-.51.28,39.72,39.72,0,0,0,0,4.5.35.35,0,0,0,.51.28A14.56,14.56,0,0,0,31.61,94,.34.34,0,0,0,31.61,93.56Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    (click)="pause()"
                    class="timer_cls-4"
                    d="M43.72,91.56a5.62,5.62,0,0,0-1.16,0,.33.33,0,0,0-.3.32V95.7a.33.33,0,0,0,.3.32,7.49,7.49,0,0,0,1.16,0,.33.33,0,0,0,.3-.32V91.88A.33.33,0,0,0,43.72,91.56Zm2.94,0a5.62,5.62,0,0,0-1.16,0,.33.33,0,0,0-.3.32V95.7a.33.33,0,0,0,.3.32,7.49,7.49,0,0,0,1.16,0,.33.33,0,0,0,.3-.32V91.88A.33.33,0,0,0,46.66,91.56Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    (click)="stop()"
                    class="timer_cls-4"
                    d="M61.89,92a.4.4,0,0,0-.35-.35,16.48,16.48,0,0,0-3.58,0,.39.39,0,0,0-.34.35,16.66,16.66,0,0,0,0,3.6.38.38,0,0,0,.34.34,15.87,15.87,0,0,0,3.58,0,.39.39,0,0,0,.35-.34A16.66,16.66,0,0,0,61.89,92Z"
                    transform="translate(-2.45 0)"
                />
            </g>
            <g id="Klok">
                <path
                    class="timer_cls-5"
                    d="M76.39,39.86A31.19,31.19,0,1,1,45.2,8.68,31.18,31.18,0,0,1,76.39,39.86Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M17.8,39.64l-3.55,0v.65l3.54,0ZM28.47,16.57l-1.42-1.88L26.7,15l1.43,1.88ZM45.52,8.91h-.65v3.78h.65ZM31.87,16.2l-2-3.36-.55.33,2,3.36ZM26.1,18.44l-1.47-1.63-.32.29,1.47,1.63ZM47.85,8.93l-.11,2.33.43,0L48.28,9ZM33.77,13.54l-1.11-2.08-.38.21,1.11,2.08Zm8.52-2.21L42.17,9l-.43,0,.11,2.33Zm-5.76,1.19-.78-2.25-.41.14.78,2.25Zm2.85-.74L39.1,9.52l-.43.05L39,11.83ZM24,20.58l-1.58-1.51-.3.31,1.58,1.51ZM22,22.92,20.2,21.64,20,22l1.83,1.28Zm-.34,3.14-3.12-1.89-.34.56,3.13,1.89Zm39-13-.56-.33-2,3.36.56.33ZM17.11,33.79,15,33.3l-.09.42,2.1.49Zm-.51,3-2.06-.21,0,.43,2.05.21ZM19,28.1l-2-.92-.18.39,2,.92Zm-1.13,2.8-2-.67-.14.41,2,.67ZM72.57,31l2-.67L74.43,30l-2,.67ZM68.1,19.14l-.3-.32-1.58,1.51.3.31Zm.83,7.2,3.13-1.89-.34-.55-3.13,1.89Zm-3-9.49-.32-.29L64.1,18.19l.32.29Zm5.59,11.36,2-.92-.18-.39-2,.92Zm1.8,5.72,2.1-.49L75.29,33l-2.11.49ZM70.19,21.69l-.25-.36-1.83,1.28.25.36Zm3.55,15.24,2.05-.21-.05-.43-2,.21ZM57.36,11.39l-1.11,2.08.38.2,1.11-2.07Zm6.08,3.37-.35-.26-1.43,1.88.35.26ZM54.27,10.2l-.78,2.25.41.14.78-2.25Zm-3.35-.76-.28,2.27.43,0,.28-2.26ZM72.7,40.19l3.55,0v-.65l-3.54,0ZM45,70.9h.65V67.12H45ZM18.92,51.31l-2,.92.18.39,2-.91ZM17.83,48.5l-2,.67.14.41,2-.67Zm3.64,4.69-3.13,1.89.34.55,3.13-1.89ZM17.12,45.6l-2.1.48.09.42L17.22,46ZM41.85,70.78l.43,0,.12-2.32-.44,0Zm-3.07-.54.43.05L39.49,68,39.06,68ZM16.66,42.59l-2.05.22.05.43L16.71,43Zm12.77,24L30,67l2-3.36-.56-.33Zm6,2.76.41.15.78-2.25-.41-.15Zm-8.63-4.54.34.26,1.42-1.87L28.24,63Zm-6.76-7,.25.35,1.83-1.28-.24-.36ZM32.39,68.14l.38.2,1.11-2.07-.37-.21Zm-8-5.43.32.29,1.47-1.63-.32-.29Zm-2.24-2.29.3.32,1.57-1.52-.29-.31Zm26.06,8,.11,2.32h.44l-.12-2.33Zm2.91-.45.27,2.27.43,0-.28-2.27ZM54,67.19l.78,2.25.41-.14-.78-2.25Zm2.75-1,1.11,2.08.39-.2L57.13,66Zm1.9-2.66,2,3.36.56-.33-2-3.36Zm3.26-.4L63.34,65l.34-.26-1.42-1.88Zm2.43-1.81,1.47,1.63.32-.29L64.66,61Zm2.13-2.14L68,60.67l.3-.32-1.57-1.5Zm1.88-2.28,1.83,1.28.25-.36L68.6,56.53Zm3.19-5.21,2,.91.19-.38-2-.93Zm1.13-2.8,2,.67.14-.41-2-.67ZM73.42,46l2.11.49.1-.42-2.11-.49Zm.51-3,2.06.22,0-.43-2-.22ZM68.84,53.71,72,55.59,72.3,55l-3.13-1.89Z"
                    transform="translate(-2.45 0)"
                />
            </g>
            <g id="cijfers">
                <path
                    class="timer_cls-6"
                    d="M22.19,8.77a1.72,1.72,0,0,0,1.31.64A1.24,1.24,0,0,0,24.82,8.2,1.27,1.27,0,0,0,23.45,7a1.93,1.93,0,0,0-1,.3L22,7.08l.3-3h3v.73H23l-.15,1.27a2.3,2.3,0,0,1,0,.31h0a1.69,1.69,0,0,1,.77-.19,2,2,0,0,1,2.09,2,2,2,0,0,1-2.12,2,2.33,2.33,0,0,1-1.84-.83Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M27,8.77a1.73,1.73,0,0,0,1.32.64A1.24,1.24,0,0,0,29.61,8.2,1.27,1.27,0,0,0,28.24,7a1.89,1.89,0,0,0-1,.3l-.49-.18.3-3h3v.73h-2.3l-.14,1.27a1.6,1.6,0,0,1-.05.31h0a1.69,1.69,0,0,1,.77-.19,2,2,0,0,1,2.1,2,2,2,0,0,1-2.13,2,2.32,2.32,0,0,1-1.83-.83Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M43.28,3.09c0-1.72.52-3.09,2.11-3.09s2.13,1.37,2.13,3.09S47,6.21,45.39,6.21,43.28,4.83,43.28,3.09Zm3.38,0c0-1.3-.28-2.32-1.27-2.32s-1.25,1-1.25,2.32.28,2.34,1.25,2.34S46.66,4.4,46.66,3.09Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M60.85,8.77a1.7,1.7,0,0,0,1.31.64A1.24,1.24,0,0,0,63.48,8.2,1.27,1.27,0,0,0,62.11,7a1.93,1.93,0,0,0-1,.3l-.48-.18.29-3h3v.73H61.65L61.5,6.11a2.3,2.3,0,0,1,0,.31h0a1.76,1.76,0,0,1,.78-.19,2,2,0,0,1,2.09,2,2,2,0,0,1-2.13,2,2.32,2.32,0,0,1-1.83-.83Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M75.41,23.82h1.32V19.94c0-.18,0-.37,0-.37h0a1.47,1.47,0,0,1-.29.35l-.56.55-.51-.53,1.43-1.39h.75v5.27h1.31v.73H75.41Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M79.62,21.54c0-1.72.52-3.09,2.12-3.09s2.13,1.37,2.13,3.09-.52,3.11-2.13,3.11S79.62,23.27,79.62,21.54Zm3.39,0c0-1.3-.28-2.32-1.27-2.32s-1.26,1-1.26,2.32.28,2.34,1.26,2.34S83,22.85,83,21.54Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M79.51,41.54h1.32V37.67c0-.19,0-.38,0-.38h0a1.2,1.2,0,0,1-.29.35l-.56.55-.51-.52,1.44-1.4h.75v5.27H83v.73H79.51Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M84.06,40.93a1.73,1.73,0,0,0,1.32.65,1.25,1.25,0,0,0,1.32-1.22,1.27,1.27,0,0,0-1.37-1.23,1.89,1.89,0,0,0-1,.3l-.49-.18.3-3h3V37h-2.3l-.14,1.27a1.62,1.62,0,0,1,0,.32h0a1.69,1.69,0,0,1,.77-.19,2,2,0,0,1,2.09,2,2,2,0,0,1-2.12,2,2.34,2.34,0,0,1-1.84-.84Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M75.05,60c0-2.14,2.94-2.45,2.94-3.86a1,1,0,0,0-1.08-1,1.55,1.55,0,0,0-1.22.76l-.62-.42A2.17,2.17,0,0,1,77,54.4a1.72,1.72,0,0,1,1.89,1.72c0,2-2.86,2.28-2.88,3.65h3v.73H75.09A2.53,2.53,0,0,1,75.05,60Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M80,57.49c0-1.73.52-3.09,2.11-3.09s2.13,1.36,2.13,3.09-.52,3.11-2.13,3.11S80,59.22,80,57.49Zm3.38,0c0-1.3-.28-2.32-1.27-2.32s-1.25,1-1.25,2.32.28,2.34,1.25,2.34S83.36,58.8,83.36,57.49Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M60.64,74.35c0-2.14,2.94-2.44,2.94-3.85a1,1,0,0,0-1.08-1,1.52,1.52,0,0,0-1.21.77l-.62-.42a2.14,2.14,0,0,1,1.89-1.14,1.73,1.73,0,0,1,1.9,1.73c0,2-2.87,2.27-2.89,3.64h3v.73H60.68A3.73,3.73,0,0,1,60.64,74.35Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M65.91,73.47a1.73,1.73,0,0,0,1.32.65,1.25,1.25,0,0,0,1.31-1.22,1.26,1.26,0,0,0-1.36-1.23,1.93,1.93,0,0,0-1,.29l-.49-.17.3-3h3v.73H66.71l-.15,1.27a1.16,1.16,0,0,1,0,.31h0a1.76,1.76,0,0,1,.77-.18,2,2,0,0,1,2.09,2,2,2,0,0,1-2.12,2,2.35,2.35,0,0,1-1.84-.83Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M41.46,78.07a2.15,2.15,0,0,0,1.46.66,1.14,1.14,0,0,0,1.22-1.1c0-.74-.66-1.1-1.39-1.1h-.42l-.2-.45,1.31-1.54a4.72,4.72,0,0,1,.38-.39v0s-.18,0-.51,0h-2v-.73h3.58V74l-1.63,1.88A1.8,1.8,0,0,1,45,77.6a2,2,0,0,1-2,1.93,2.77,2.77,0,0,1-2-.82Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M46,76.42c0-1.73.52-3.1,2.11-3.1s2.13,1.37,2.13,3.1-.52,3.11-2.13,3.11S46,78.15,46,76.42Zm3.38,0c0-1.3-.28-2.33-1.27-2.33s-1.25,1-1.25,2.33.28,2.33,1.25,2.33S49.4,77.72,49.4,76.42Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M21.58,73.9a2.15,2.15,0,0,0,1.45.65,1.15,1.15,0,0,0,1.23-1.09c0-.74-.66-1.11-1.4-1.11h-.41l-.2-.45,1.31-1.54a3.9,3.9,0,0,1,.37-.39v0a3.45,3.45,0,0,1-.51,0h-2v-.73H25v.53l-1.63,1.88a1.81,1.81,0,0,1,1.76,1.76,2,2,0,0,1-2,1.93,2.76,2.76,0,0,1-1.95-.81Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M26.47,73.91a1.73,1.73,0,0,0,1.32.64,1.24,1.24,0,0,0,1.32-1.21,1.27,1.27,0,0,0-1.37-1.24,1.93,1.93,0,0,0-1,.3l-.48-.18.29-3h3V70h-2.3l-.14,1.27a2.3,2.3,0,0,1,0,.31h0a1.76,1.76,0,0,1,.78-.19,2,2,0,0,1,2.09,2,2,2,0,0,1-2.13,2A2.32,2.32,0,0,1,26,74.52Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M6.68,58.3l2.77-3.87h1v3.68h.82v.71h-.82v1.61H9.59V58.82H6.68Zm2.91-.19V55.92c0-.28,0-.59,0-.59h0a3.1,3.1,0,0,1-.29.49l-1.7,2.27v0Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M12.1,57.42c0-1.72.52-3.09,2.12-3.09s2.13,1.37,2.13,3.09-.52,3.11-2.13,3.11S12.1,59.15,12.1,57.42Zm3.39,0c0-1.3-.28-2.32-1.27-2.32S13,56.12,13,57.42s.28,2.34,1.26,2.34S15.49,58.73,15.49,57.42Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M2.45,40.63l2.78-3.86h1v3.68H7v.71H6.19v1.61H5.36V41.16H2.45Zm2.91-.18V38.26c0-.28,0-.59,0-.59h0a3.63,3.63,0,0,1-.3.49l-1.7,2.27v0Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M8.22,41.42a1.72,1.72,0,0,0,1.31.65,1.24,1.24,0,0,0,1.32-1.22,1.27,1.27,0,0,0-1.37-1.23,1.93,1.93,0,0,0-1,.3L8,39.74l.3-3h3v.73H9l-.15,1.26a2.31,2.31,0,0,1,0,.32h0a1.69,1.69,0,0,1,.77-.19,2,2,0,0,1,2.09,2,2,2,0,0,1-2.12,2A2.33,2.33,0,0,1,7.75,42Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M7.48,23.51a1.69,1.69,0,0,0,1.31.65,1.24,1.24,0,0,0,1.32-1.22,1.27,1.27,0,0,0-1.37-1.23,1.93,1.93,0,0,0-1,.3l-.48-.18.29-3h3v.73H8.27l-.14,1.26a2.31,2.31,0,0,1,0,.32h0A1.76,1.76,0,0,1,8.88,21a2,2,0,0,1,2.09,2,2,2,0,0,1-2.13,2A2.32,2.32,0,0,1,7,24.13Z"
                    transform="translate(-2.45 0)"
                />
                <path
                    class="timer_cls-6"
                    d="M11.92,21.85c0-1.73.52-3.1,2.12-3.1s2.12,1.37,2.12,3.1S15.64,25,14,25,11.92,23.58,11.92,21.85Zm3.38,0c0-1.3-.28-2.32-1.26-2.32s-1.26,1-1.26,2.32.28,2.34,1.26,2.34S15.3,23.16,15.3,21.85Z"
                    transform="translate(-2.45 0)"
                />
            </g>
            <g>
                <path
                    transform="rotate(-90 42.55 39.55)"
                    class="timer_cls-7"
                    [attr.d]="
                        'M42.55,39.55L73.55,39.55A' +
                        radius +
                        ',' +
                        radius +
                        ',0,' +
                        arcShift +
                        ',1,' +
                        x +
                        ',' +
                        y +
                        ''
                    "
                />
            </g>
            @if (showAlarm) {
            <g id="alarm">
                <rect
                    class="timer_cls-5"
                    x="30.68"
                    y="35.56"
                    width="25.52"
                    height="8.88"
                    rx="2.83"
                />
                <rect
                    class="timer_cls-8"
                    x="30.68"
                    y="35.56"
                    width="25.52"
                    height="8.88"
                    rx="2.83"
                />
                <text
                    style="fill: red"
                    class="timer_cls-12"
                    transform="translate(33.75 42.56)"
                >
                    <tspan class="timer_cls-13">00</tspan>
                    <tspan x="8.5" y="-0.5">:</tspan>
                    <tspan x="11" y="0">00</tspan>
                </text>
            </g>
            } @if (!showAlarm) {
            <g id="timer_museo_sans_500" data-name="timer_museo sans 500">
                <path
                    class="timer_cls-10"
                    d="M14.35,39.72"
                    transform="translate(-2.45 0)"
                />
                <rect
                    class="timer_cls-5"
                    x="30.68"
                    y="35.56"
                    width="25.52"
                    height="8.88"
                    rx="2.83"
                />
                <rect
                    class="timer_cls-11"
                    x="30.68"
                    y="35.56"
                    width="25.52"
                    height="8.88"
                    rx="2.83"
                />
                <text class="timer_cls-12" transform="translate(33.75 42.56)">
                    <tspan class="timer_cls-13">
                        {{ timerMinutes | prependZeros }}
                    </tspan>
                    <tspan x="8.5" y="-0.5">:</tspan>
                    <tspan x="11" y="0">
                        {{ timerSeconds | prependZeros }}
                    </tspan>
                </text>
            </g>
            }
        </g>
    </svg>
</ng-template>
